import { EventEmitter, Injectable, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ResetSaveButtonService implements OnDestroy {
  resetClick: EventEmitter<void> = new EventEmitter<void>();
  saveClick: EventEmitter<void> = new EventEmitter<void>();

  _isResetDisabled$ = new BehaviorSubject<boolean>(true);
  _isSaveDisabled$ = new BehaviorSubject<boolean>(true);

  isResetDisabled$ = this._isResetDisabled$.asObservable();
  isSaveDisabled$ = this._isSaveDisabled$.asObservable();

  set isResetDisabled(value){
    this._isResetDisabled$.next(value);
  };
  get isResetDisabled(): boolean{

    return this._isResetDisabled$.value;
  };

  set isSaveDisabled(value){
    this._isSaveDisabled$.next(value);
  };
  get isSaveDisabled(): boolean{
    return this._isSaveDisabled$.value;
  };

  constructor() { }

  ngOnDestroy(): void {
    this.resetClick.complete();
    this.saveClick.complete();
    this._isResetDisabled$.complete();
    this._isSaveDisabled$.complete();
  }
}
